/**
 * @file contactInquires.ts
 * @module api/apiJSON/contactInquires
 * @description Defines contactInquires API request configuration and payload helpers.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { IListInquires } from "../../types";
export const inquiresJSON = {
  listInquires: ({
    pageNo,
    limit,
    sortKey,
    sortOrder,
    searchTerm,
    warehouse
  }: IListInquires) => {
    let params:any = {
      pageNo: pageNo,
      limit: limit,
      sortKey: sortKey,
      sortOrder: sortOrder,
      needCount: true,
      searchTerm: searchTerm,
    };
    if (warehouse) {
      params = {
        ...params,
        warehouse: warehouse,
      };
    }
  },
};
